import _ from 'underscore';
import Backbone from '@polleverywhere/backbone';

var Logger = /*#__PURE__*/function () {
  function Logger(app, level) {
    if (level === void 0) {
      level = 'none';
    }

    this.app = app;
    this.level = level;

    _.extend(this, Backbone.Events);

    if (this.level === 'all') {
      this.listenTo(this.app, 'all', this.handleEvent);
    } else {
      this.listenTo(this.app, "log:" + this.level, this.handleLogEvent.bind(this));
    }
  }

  var _proto = Logger.prototype;

  _proto.handleLogEvent = function handleLogEvent() {
    var args = Array.prototype.slice.call(arguments);
    args.splice(0, 0, "log:" + this.level);
    return this.handleEvent.apply(this, args);
  };

  _proto.handleEvent = function handleEvent() {
    try {
      var args = Array.prototype.slice.call(arguments);
      var event = args.shift();
      args.splice(0, 0, "[" + event + "]");
      return typeof console !== 'undefined' && console !== null ? console.log.apply(console, args) : undefined;
    } catch (error) {
      return typeof console !== 'undefined' && console !== null ? console.log(JSON.stringify(arguments)) : undefined;
    }
  };

  return Logger;
}();

export { Logger as default };